'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 5;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 5;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 1rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 90%;\n  max-height: 90%;\n  background-color: white;\n  border: 1px solid #ccc;\n  @media(min-width: 950px) {\n    max-width: 900px;\n  }\n'], ['\n  display: flex;\n  padding: 1rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 90%;\n  max-height: 90%;\n  background-color: white;\n  border: 1px solid #ccc;\n  @media(min-width: 950px) {\n    max-width: 900px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  flex-direction: row;\n  overflow-y: auto;\n\n  &>div {\n    width: 33%;\n    padding: 0.5rem;\n    min-height: 0;\n    text-align: center;\n  }\n  img {\n    max-width: 100%;\n  }\n\n  @media(orientation: portrait) {\n    display: block;\n    &>div {\n      width: calc(100% - 1rem);\n    }\n  }\n\n  button, .landing-btn {\n    cursor: pointer;\n    font-size: 1.1rem;\n    padding: 1rem;\n    width: 100%;\n  }\n\n  h3 {\n    margin-bottom: 0.1rem;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  flex-direction: row;\n  overflow-y: auto;\n\n  &>div {\n    width: 33%;\n    padding: 0.5rem;\n    min-height: 0;\n    text-align: center;\n  }\n  img {\n    max-width: 100%;\n  }\n\n  @media(orientation: portrait) {\n    display: block;\n    &>div {\n      width: calc(100% - 1rem);\n    }\n  }\n\n  button, .landing-btn {\n    cursor: pointer;\n    font-size: 1.1rem;\n    padding: 1rem;\n    width: 100%;\n  }\n\n  h3 {\n    margin-bottom: 0.1rem;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _terms = require('../terms/terms');

var _terms2 = _interopRequireDefault(_terms);

var _paypalButton = require('./paypal-button');

var _paypalButton2 = _interopRequireDefault(_paypalButton);

var _directToShowButton = require('./direct-to-show-button');

var _directToShowButton2 = _interopRequireDefault(_directToShowButton);

var _fundraisingButton = require('./fundraising-button');

var _fundraisingButton2 = _interopRequireDefault(_fundraisingButton);

var _exhibitorButton = require('./exhibitor-button');

var _exhibitorButton2 = _interopRequireDefault(_exhibitorButton);

var _welcomeVideoButton = require('./welcome-video-button');

var _welcomeVideoButton2 = _interopRequireDefault(_welcomeVideoButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Panel = _styledComponents2.default.div(_templateObject2);

var Main = _styledComponents2.default.div(_templateObject3);

/** @class Entry
  * A component for welcoming a customer to the show,
  * providing details about the show and methods
  * to log in.
  * @prop {string} name - the name of the expo show
  * @prop {url} logo - the source of the expo logo image
  * @prop {url} sponsors - the source of the expo sponsors image
  * @prop {url} fundraising - the source of the expo fundraising image
  * @prop {Date} opens - the date the show opens
  * @prop {Date} closes - the date the show closes
  * @prop {array} beneficiaries - a list of charitable beneficiaries of the show
  * @prop {array} exhibitors - a list of exhibitors appearing in the show
  * @prop {array} deals - a list of gift card deals in the show gift card package
  * @prop {url} welcomeVideo - the welcome video for the show
  */

var Entry = function (_Component) {
  _inherits(Entry, _Component);

  function Entry() {
    _classCallCheck(this, Entry);

    return _possibleConstructorReturn(this, (Entry.__proto__ || Object.getPrototypeOf(Entry)).apply(this, arguments));
  }

  _createClass(Entry, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            Panel,
            null,
            _react2.default.createElement(
              Main,
              null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', { src: this.props.logo }),
                _react2.default.createElement('img', { src: this.props.sponsors }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'SHOW OPENS'
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)(new Date(this.props.opens)).format("MMM. Do"),
                  ' and closes ',
                  (0, _moment2.default)(new Date(this.props.closes)).format("MMM. Do, YYYY")
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', { src: this.props.fundraising }),
                _react2.default.createElement(_paypalButton2.default, null)
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_welcomeVideoButton2.default, { video: this.props.welcomeVideo }),
                _react2.default.createElement(_exhibitorButton2.default, { name: this.props.name, exhibitors: this.props.exhibitors }),
                _react2.default.createElement(_fundraisingButton2.default, { name: this.props.name, deals: this.props.deals, beneficiaries: this.props.beneficiaries }),
                _react2.default.createElement(_directToShowButton2.default, null),
                _react2.default.createElement(
                  'a',
                  { href: '#', onClick: function onClick(event) {
                      event.preventDefault();window.vexpo.requestLoginLink();
                    } },
                  'Request Personal Login Link'
                )
              )
            ),
            _react2.default.createElement(_terms2.default, { name: this.props.name, supportEmail: this.props.supportEmail })
          )
        ),
        _react2.default.createElement(_stage2.default, this.props.stage)
      );
    }
  }]);

  return Entry;
}(_react.Component);

exports.default = Entry;


Entry.propTypes = {
  name: _propTypes2.default.string.isRequired,
  logo: _propTypes2.default.string.isRequired,
  sponsors: _propTypes2.default.string.isRequired,
  fundraising: _propTypes2.default.string.isRequired,
  opens: _propTypes2.default.number.isRequired,
  closes: _propTypes2.default.number.isRequired,
  beneficiaries: _propTypes2.default.object.isRequired,
  exhibitors: _propTypes2.default.array.isRequired,
  deals: _propTypes2.default.array.isRequired,
  supportEmail: _propTypes2.default.string.isRequired,
  welcomeVideo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/entry/entry.js
// module id = 698
// module chunks = 0